<template>

<div class="setting" :class="{'is-locked': isLocked, 'is-inline': isInline}">

    <div class="setting-head" v-on:click="onHeadClick" v-if="!isInline">
            
        <div class="setting-name">{{ title }}</div>

        <div class="setting-value" v-if="!isEmpty">{{ value }}</div>
        <div class="setting-value" v-if="isEmpty">{{ placeholder }}</div>

        <i class="fa-sharp fa-chevron-down setting-caret" v-if="is.expanded && !isLocked" />
        <i class="fa-sharp fa-chevron-right setting-caret" v-if="!is.expanded && !isLocked" />
        <i class="fa-sharp fa-lock setting-caret is-locked" v-if="isLocked" />

    </div>

    <div class="setting-content" v-if="is.expanded && !isLocked">

        <slot></slot>

    </div>

</div>

</template>

<script>

export default {

    props: ['title', 'value', 'placeholder', 'isInline', 'isLocked'],

    data: function() {

        return {
            is: {
                expanded: false
            }
        }

    },

    created: function() {

        if (this.isInline) this.is.expanded = true

    },

    computed: {

        isEmpty: function() {

            return !this.value

        }

    },

    methods: {

        onHeadClick: function() {

            this.is.expanded = !this.is.expanded

        }

    }

}

</script>

<style scoped>

.setting {
    border-bottom: 1px solid rgb(54, 97, 119);
}

.setting.is-inline {
    border-bottom: 0px;
}

.setting.is-locked {
    pointer-events: none;
}

.is-mobile .setting:not(.is-inline) {
    border-bottom: 1px solid #eee;
}

.is-desktop .setting:not(.is-inline):hover {
    background-color: rgba(255, 255, 255, 0.05);
}

.setting-head {
    cursor: pointer;
    padding: 10px 20px;
    user-select: none;
}

.is-mobile .setting-head {
    padding: 10px;
}

.setting-name {
    font-weight: 500;
    color: #fff;
    line-height: 20px;
    font-size: 16px;
}

.is-mobile .setting-name {
    color: #343434;
}

.setting-value {
    font-weight: 400;
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    opacity: 0.4;
}

.is-mobile .setting-value {
    color: #343434;
}

.setting-caret {
    color: #fff;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    position: absolute;
    right: 20px;
    top: 50%;
    margin-top: -12px;
}

.is-mobile .setting-caret {
    color: #343434;
}

.setting-caret.is-locked {
    opacity: 0.25;
}

.setting-content {
    padding: 0px 10px 10px 10px;
}

.setting-content >>> .textbox {
    margin-bottom: 0px;
}

</style>